import { tss } from "tss-react/mui";
import { DEFAULT_LEFT_PADDING, DEFAULT_RIGHT_PADDING, MOBILE_LEFT_PADDING, MOBILE_RIGHT_PADDING, WINDOW_MAX_WIDTH } from "../../../layout/Layout.styles";

export const useStyles = tss.create(({ theme }) => ({
	root: {
		backgroundColor: '#F9F9FB',
		position: 'relative',
		overflow: 'hidden',
		[theme.breakpoints.down('md')]: {
		}
	},
	container: {
		margin: '0 auto',
		maxWidth: WINDOW_MAX_WIDTH,
		paddingLeft: DEFAULT_LEFT_PADDING,
		paddingRight: DEFAULT_RIGHT_PADDING,
		paddingBottom: 48,
		paddingTop: 48,
		overflow: 'hidden',
		'& > div': {
			textAlign: 'center',
		},
		[theme.breakpoints.down('md')]: {
			paddingLeft: MOBILE_LEFT_PADDING,
			paddingRight: MOBILE_RIGHT_PADDING,
			paddingBottom: 20,
			paddingTop: 40,
		}
	},
	title: {
		color: theme.palette.tertiary.main,
		fontSize: 42,
		fontWeight: 400,
		letterSpacing: '0.18px',
		lineHeight: '31px',
		marginBottom: 32,
		textAlign: 'center',
		width: '100%',
		'& strong': {
			color: theme.palette.primary.main,
		},
		[theme.breakpoints.down('md')]: {
			fontSize: 20,
			lineHeight: '31px',
			fontWeight: 400,
			letterSpacing: ' 0.18px',
			marginBottom: 40,
			paddingLeft: 0,
			paddingRight: 0,
		}
	},
	inputContainer: {
		textAlign: 'center',
	},
	postNameInput: {
		backgroundColor: 'white',
		border: '1px solid #858585',
		height: 56,
		width: 499,
		maxWidth: '100%',
		[theme.breakpoints.down('md')]: {
			width: '100%',
		},
	},
	pattern: {
		position: 'absolute',
		display: 'block',
		top: 0,
		'&.l': {
			left: 0,
		},
		'&.r': {
			right: 0,
		}
	}
}))